import {
  CustomDrawer,
  FormFooter,
  FormTextField,
  FormSelect,
} from "@shared/components";
import {
  RoleManagementFormValues,
  UpdateRoleManagementFormProps,
} from "../utils/types";
import { Form, Formik } from "formik";
import {
  RoleManagementFormFields,
  RoleManagementFormInitialValues,
  RoleManagementFormValidationSchema,
} from "../utils/constants";
import { useMemo } from "react";
import { Box } from "@mui/material";

const RoleManagementForm = ({
  open,
  onClose,
  title,
  showCloseButton,
  initialValues,
  onSubmit,
  disable,
  rolesOptions,
}: UpdateRoleManagementFormProps) => {
  const mergedInitialValues = useMemo(
    () => ({
      ...RoleManagementFormInitialValues,
      ...initialValues,
    }),
    [initialValues]
  );

  return (
    <CustomDrawer
      open={open}
      onClose={onClose}
      title={title}
      showCloseButton={showCloseButton}
    >
      <Formik
        enableReinitialize
        initialValues={mergedInitialValues}
        validationSchema={RoleManagementFormValidationSchema}
        onSubmit={onSubmit}
      >
        {(formikProps) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              overflow: "hidden",
              paddingBottom: "80px",
            }}
          >
            <Box
              sx={{
                position: "relative",
                p: 2,
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overflowX: "hidden",
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              {RoleManagementFormFields.map(({ name, label, type }) => {
                const value =
                  formikProps.values[name as keyof RoleManagementFormValues];
                const isDisabled = name !== "role";

                if (type === "dropdown") {
                  return (
                    <FormSelect
                      key={name}
                      name={name}
                      label={label}
                      value={String(value)}
                      onChange={(e) => formikProps.handleChange(e)}
                      options={rolesOptions || []}
                      touched={formikProps.touched as Record<string, unknown>}
                      errors={formikProps.errors as Record<string, unknown>}
                      disabled={isDisabled}
                      required
                    />
                  );
                }

                return (
                  <FormTextField
                    key={name}
                    type={type}
                    name={name}
                    label={label}
                    value={value}
                    onChange={(e) => formikProps.handleChange(e)}
                    touched={formikProps.touched as Record<string, unknown>}
                    errors={formikProps.errors as Record<string, unknown>}
                    disabled={isDisabled}
                  />
                );
              })}
            </Box>
            <FormFooter
              disable={disable || !formikProps.dirty}
              isSubmitting={formikProps.isSubmitting}
            />
          </Form>
        )}
      </Formik>
    </CustomDrawer>
  );
};

export default RoleManagementForm;
